import React, { useState, useEffect } from 'react';
// import DefaultUser from '../../../assets/images/default-user.svg';
import { useSelector } from 'react-redux';
// import user from '../../../assets/images/user-image.png';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useKidListFunctionality from "../../customHooks/kidListHook";

const   Header = () => {
    const { user } = useSelector(({ auth }) => auth);
    const [isBodyClassToggled, setIsBodyClassToggled] = useState(false);
    const { messageCountData } = useSelector(({dashboard}) => dashboard);
    const notficationCount = messageCountData?.length > 0 ? messageCountData[0]?.NotificationCount : 0;
    const { getImage } = useKidListFunctionality();
    const history = useHistory();
    const handleButtonClick = () => {
        setIsBodyClassToggled((prevState) => !prevState);
      };

      useEffect(() => {
        const body = document.body;
        if (isBodyClassToggled) {
          body.classList.add('toggle-menu');
        } else {
          body.classList.remove('toggle-menu');
        }
    
        // Clean up the class when the component unmounts
        return () => {
          body.classList.remove('toggle-menu');
        };
      }, [isBodyClassToggled]);

    return (
        <div className="navbar-custom">
            <div className="topbar container-fluid">
                {/* <div className="d-flex align-items-center gap-lg-2 gap-1">
                    <div className="app-search d-none d-md-block">
                        <form>
                            <div className="input-group">
                                <span
                                    className="input-group-text border-end-0 fs-5 text-dark pe-0"
                                    id="basic-addon3"
                                >
                                    <i className="icon-search" id="togglePassword"></i>
                                </span>
                                <input type="search" className="form-control border-start-0" placeholder="Search" id="top-search" />
                            </div>
                        </form>
                    </div>
                </div> */}
                <ul className="topbar-menu d-flex align-items-center gap-3 p-0">
                    <li>
                        <span 
                            className="h-notification c-pointer" 
                            onClick={() => history.push("/notifications")}
                        >
                            <i className={`icon-bell ${notficationCount > 0 ? 'bell-with-dot' : ''}`} style={{position: 'relative'}} />
                        </span>
                    </li>
                    <li>
                        {/* <a href="#" className="nav-link dropdown-toggle px-2 nav-user" type="button" data-bs-toggle="dropdown" aria-expanded="false"> */}
                        <div className='nav-link px-2 nav-user'>
                            <div>
                                <h6 className="my-0 text-capitalize">{user?.name}</h6>
                            </div>
                            <span className="">
                                <img src={getImage(user?.image)} alt='' height={40} width={40} className='account-user-avatar'/>
                            </span>
                        </div>
                        {/* </a> */}
                        {/* <div className="dropdown-menu">
                            ...
                        </div> */}
                    </li>
                </ul>
                <i className={`d-block d-xl-none fs-2 text-black pt-cursor p-1 ${isBodyClassToggled ? 'icon-cancel' : 'icon-hamburger'}`} onClick={handleButtonClick} />
            </div>
        </div>
    )
}

export default Header;